import { Entity } from '@adornis/baseql/decorators.js';
import { BaseEditExtension } from '@chancenwerk/_buildify/edit-ui/entities/BaseEditExtension.js';

/**
 * @entity BaseKPFEditDefaultExtension
 */
@Entity()
export class BaseKPFEditDefaultExtension extends BaseEditExtension {
  public static override _class = 'BaseKPFEditDefaultExtension';
}
